'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import BookingFormField from './BookingFormField';
import PropTypes from 'prop-types';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { jsx as _jsx } from "react/jsx-runtime";
const displayName = 'CustomFormInputs';
const propTypes = {
  formFields: PropTypes.instanceOf(List).isRequired,
  customFormFields: PropTypes.instanceOf(ImmutableMap).isRequired,
  onCustomFormFieldChange: PropTypes.func.isRequired,
  formStateValidation: PropTypes.instanceOf(ImmutableMap).isRequired,
  disabled: PropTypes.bool
};
const CustomFormInputs = ({
  formFields,
  customFormFields,
  onCustomFormFieldChange,
  formStateValidation,
  disabled
}) => /*#__PURE__*/_jsx("div", {
  style: {
    wordWrap: 'break-word'
  },
  children: formFields.map(field => {
    return /*#__PURE__*/_jsx(BookingFormField, {
      fieldValue: customFormFields.get(field.name),
      fieldName: field.name,
      validation: formStateValidation.get(field.name),
      setFormValue: onCustomFormFieldChange,
      type: field.type,
      fieldType: field.fieldType,
      isRequired: field.isRequired,
      fieldLabel: propertyLabelTranslator(field.label),
      fieldOptions: field.options,
      fieldIsCustom: field.isCustom,
      numberDisplayHint: field.numberDisplayHint,
      disabled: disabled
    }, `${field.name}`);
  })
});
CustomFormInputs.displayName = displayName;
CustomFormInputs.propTypes = propTypes;
export default CustomFormInputs;